import React, { PureComponent } from 'react';
import classnames from 'classnames';

class Icon extends PureComponent {
  render() {
    const { className, icon, onClick, title, style } = this.props;
    return (
      <span
        className={classnames('icon', `icon_${icon}`, className)}
        title={title}
        style={style}
        onClick={onClick}
      />
    );
  }
}

export default Icon;
